import Box from '@material-ui/core/Box'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import { makeStyles, Theme } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import React, { useContext, useEffect, useState } from 'react'

import colorContext from '../../Context/colorContext'
import { getNotices, INotice } from '../../services/avisos'
import { onMessageListener } from '../../services/firebase'
import getCookie from '../../utils/getCookies'
import { sanitizeHtml } from '../../utils/sanitizeHtml'

export default function ModalAlertsDialog(): JSX.Element {
  const { colors } = useContext(colorContext)
  const useStyles = makeStyles((theme: Theme) => ({
    root: {
      '&.MuiDialogContent-root': {
        backgroundColor: colors.colorBackgroundSecundary,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: colors.textBody,
    },
    titleDialog: {
      color: colors.textBody,
      backgroundColor: colors.colorBackgroundSecundary,
      paddingTop: 20,
      paddingBottom: 20,
      paddingRight: 40,
    },
    contentDialog: {
      color: colors.textBody,
      backgroundColor: colors.colorBackgroundSecundary,
      width: '100%',
      '& img': {
        maxWidth: '100%',
        height: 'auto',
        display: 'block',
        margin: '0 auto',
      },
    },
  }))
  const classes = useStyles()
  const [open, setOpen] = useState<boolean>(false)
  const [notice, setNotice] = useState<INotice | undefined>()

  const loadCurrentNotices = async () => {
    try {
      const { data } = await getNotices()
      if ('id' in data) {
        setNotice(data)
      }
    } catch (error) {
      console.log(error)
    }
  }
  onMessageListener()
    .then(() => {
      loadCurrentNotices()
    })
    .catch((err) => console.log('failed: ', err))
  const handleClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    loadCurrentNotices()
  }, [])

  useEffect(() => {
    const noticeViewed = getCookie('notice-visualized')
    if (notice && noticeViewed !== notice.id.toString()) {
      document.cookie = `notice-visualized=${encodeURIComponent(
        notice.id.toString(),
      )};path=/`
      setOpen(true)
    } else {
      setOpen(false)
    }
  }, [notice])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      fullWidth
      maxWidth="md"
    >
      <DialogTitle className={classes.titleDialog}>
        {notice?.titulo}
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers classes={{ root: classes.root }}>
        <Box
          className={classes.contentDialog}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(notice?.conteudo) || '',
          }}
        />
      </DialogContent>
    </Dialog>
  )
}
